
export class SaveContactLicenseInfo {
    id: number;
    contactId: number;
    licenseTypeId: number
    licenseNumber: string;
    licenseEndorsements: string;
    licenseRestrictions: string;
    stateProvinceId: number;
    expirationDate: Date;
    isActive: boolean
    public deactivateOtherLicenses = true;
    constructor(
        id: number, contactId: number, licenseTypeId: number, licenseNumber: string, licenseEndorsements: string,
        licenseRestrictions: string, stateProvinceId: number, expirationDate: Date, isActive: boolean,
    ){
        this.id = id;
        this.contactId = contactId;
        this.licenseTypeId = licenseTypeId;
        this.licenseNumber = licenseNumber;
        this.licenseEndorsements = licenseEndorsements;
        this.licenseRestrictions = licenseRestrictions;
        this.stateProvinceId = stateProvinceId;
        this.expirationDate = expirationDate;
        this.isActive = isActive;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/contacts/contact-nav/contact-info-category-lists/models/save-contact-license-info.ts